import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  refreshSuccessTitle: {
    description: 'sellerStore.refreshSuccessTitle',
    defaultMessage: 'Refresh Successful',
    id: 'KFAapQ',
  },
  refreshSuccessBodyVariant: {
    description: 'seller store refresh success notification body for variant',
    defaultMessage: 'You have {numberOfNewOrders, plural, one {# new order} other {# new orders} }. Reload the grid to see new orders',
    id: '+DH90U',
  },
  refreshSuccessBodyControl: {
    description: 'seller store refresh success notification body for control',
    defaultMessage:
      'Store refresh was successful. You have {numberOfNewOrUpdatedOrders, plural, one {# new or updated order} other {# new or updated orders} }. Reload the grid to see updated orders',
    id: 'FHug2z',
  },
  reloadGrid: {
    description: 'sellerStore.reloadGrid',
    defaultMessage: 'Reload Grid',
    id: 'obZj//',
  },
  termsFetchErrorTitle: {
    description: 'sellerStore.termsFetchErrorTitle',
    defaultMessage: 'Error Fetching Terms',
    id: 'N4hhJG',
  },
  termsFetchErrorBody: {
    description: 'sellerStore.termsFetchErrorBody',
    defaultMessage: 'An error occurred fetching the latest UPS terms.',
    id: 'fe5v4y',
  },
});
